import React, {useState, useEffect, useRef, useContext, useCallback} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {numbers, specialCharTextNumbers} from '../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../views/textNumberEntryView';
import NumberView from '../../views/numberTNView';
import MenuContext from '../../../context/menuContext';
import FCFTN from './fcfTN';
import D2TN from './d2TN';
import ValuesContext from '../../../context/valuesContext';

function D1TN({initiallyDisableKeypress}) {
  const [value, setValue] = useState(10);
  const {setDisableMenu, onComponent} = useContext(MenuContext);

  const onRightHold = useCallback(() => {
    setDisableMenu(true);
    onComponent(<D2TN initiallyDisableKeypress />);
    setTimeout(() => setDisableMenu(false), 500);
  }, [value]);

  return (
    <NumberView
      chars={numbers}
      focus={9}
      onChange={v => setValue(v)}
      defaultKey1={2}
      defaultKey2={2}
      defaultKey3={2}
      defaultKey4={2}
      defaultKey5={2}
      defaultKey6={2}
      defaultKey7={2}
      defaultKey8={2}
      defaultKey9={2}
      defaultKey10={12}
      defaultKey11={2}
      defaultKey12={2}
      onSave={onRightHold}
      onLeftHold={() => onComponent(<FCFTN />)}
      title="Set D1"
      caption="Enter D1 from Sensor Tag:"
      left="Hold to Cancel"
      right="Hold to Save"
      initiallyDisableKeypress={initiallyDisableKeypress}
    />
  );
}

export default D1TN;
